// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bcs-user-info-card .customCardbody {\n  margin: 0 !important;\n  padding: 0 !important;\n}\n.bcs-user-info {\n  font-size: 1.2rem;\n  text-align: center;\n  font-weight: 600;\n}", ""]);
// Exports
module.exports = exports;
